/*
 * @Author: Dong
 * @Date: 2022-04-07 13:40:11
 * @LastEditors: zhang lin
 * @LastEditTime: 2023-02-22 10:35:37
 */
import { defineMessages } from 'react-intl';
const messageObject = {
  extendedService: '扩展组件',
  install: '安装',
  upgrade: '升级',
  noinstall: '未安装',
  groupServer: '所在服务器: { ip } (运维平台服务器)',
  useable: '可用',
  used: '已用',
  total: '共',
  packPosition: '安装包放置位置',
  noPackage: '无安装包',
  packageList: '安装包列表',
  uploadPackage: '上传安装包',
  fromDatabase: '从资源库获取',
  refersh: '刷新列表',
  initPage: '未找到安装包',
};
export default defineMessages(messageObject);
